import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ProjectsGrid from "@/components/ProjectsGrid";
import Practice from "@/components/Practice";
import Contact from "@/components/Contact";
import { getLenis } from "@/hooks/useSmoothScroll";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash?.replace("#", "");
    if (!hash) return;
    const t = setTimeout(() => {
      const el = document.getElementById(hash);
      const lenis = getLenis();
      if (el && lenis) lenis.scrollTo(el, { offset: -40, duration: 1.2 });
      else if (el) el.scrollIntoView();
    }, 300);
    return () => clearTimeout(t);
  }, [location.hash]);

  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }}
      data-testid="home-page"
    >
      <Hero />
      <Marquee />
      <ProjectsGrid />
      <Practice />
      <Contact />
    </motion.main>
  );
}
